import React from 'react';
import PropTypes from 'prop-types';

const CommunityContentCard = ({ image, quote, user, userSubtitle }) => {
  return (
    <div className="community-content">
      <div className="community-content__image-box">
        <img src={image} className="community-content__image" />
      </div>
      <div className="community-content__lower-section">
        <blockquote className="community-content__quote">{quote}</blockquote>
        <div className="community-content__user">
          <cite className="community-content__user__name">{user}</cite>
          <div className="community-content__user__subtitle">
            {userSubtitle}
          </div>
        </div>
      </div>
    </div>
  );
};

CommunityContentCard.propTypes = {
  image: PropTypes.string.isRequired,
  quote: PropTypes.string.isRequired,
  user: PropTypes.string.isRequired,
  userSubtitle: PropTypes.string.isRequired,
};

export default CommunityContentCard;
